module.exports = __webpack_public_path__ + "img/42.aa9cef0f.jpg";